import * as actionTypes from './shopping-types';
import shoppingCartAPI from '../../Data/ShoppingCart';
import { fileManager } from '../../Init/indexedDB';

const INITIAL_STATE = {
    cartProducts: {},
    cartCounter: 0,
    totalQty: 0,
    designAttachment: null,
    transactionNotes: ""
}

const shopReducer = (state = INITIAL_STATE, action) => {
    let { cartProducts, cartCounter, totalQty, designAttachment } = state;
    var ownerCode = "";
    var productItem = {};
    var transactionNotes = "";
    var variantCode = "";
    var productId = 0;
    var sizeId = 0;
    var deleteCustomDesign = false;
    
    switch(action.type) {
        case actionTypes.ADD_TO_CART:
            /**
             * 1. Get items data from cart
             * 2. Check if item exists
             */
            ownerCode = action.payload.ownerCode;
            productItem = action.payload.productItem;
            transactionNotes = action.payload.transactionNotes;
            productId = productItem.productId;
            sizeId = productItem.sizeId;

            if( productId !== "transactionNotes" ) {
                // let productVariantEncode = UtilityFunction.base64encode(`${ productId }-${ sizeId }`);
                let productVariantEncode = shoppingCartAPI.controller.cartItemCode(productId, sizeId);

                if(cartProducts.hasOwnProperty(productVariantEncode)) {
                    if(cartProducts[productVariantEncode].sizeId !== sizeId) {
                        cartProducts[productVariantEncode].sizeId = sizeId;
                        cartProducts[productVariantEncode].quantity = parseInt(productItem.quantity);
                    } else {
                        cartProducts[productVariantEncode].quantity = parseInt(cartProducts[productVariantEncode].quantity) + parseInt(productItem.quantity);
                    }
                    // cartProducts[productId].quantity += productItem.quantity;
                    cartProducts[productVariantEncode].addons = productItem.addons;
                } else {
                    cartProducts[productVariantEncode] = productItem;
                    cartCounter += 1;
                }
    
                totalQty += parseInt(productItem.quantity);
            }

            shoppingCartAPI.controller.save(ownerCode, productItem, transactionNotes);
            return {
                ...state,
                cartProducts,
                cartCounter,
                totalQty,
                transactionNotes,
            };
        case actionTypes.REMOVE_FROM_CART:
            ownerCode = action.payload.ownerCode;
            variantCode = action.payload.variantCode;

            if(cartProducts.hasOwnProperty(variantCode)) {
                delete cartProducts[variantCode];
                cartCounter -= 1;
                totalQty -= 1;
            }

            deleteCustomDesign = shoppingCartAPI.controller.delete(ownerCode, variantCode);
            if( deleteCustomDesign ) {
                fileManager.deleteFile(1);
            }

            return {
                ...state,
                cartProducts,
                cartCounter,
                totalQty,
                transactionNotes: "",
                designAttachment: deleteCustomDesign ? null : designAttachment
            };
        case actionTypes.ADJUST_QTY:
            ownerCode = action.payload.ownerCode;
            variantCode = action.payload.productId;
            var { qty } = action.payload;
            deleteCustomDesign = false;

            if(cartProducts.hasOwnProperty(variantCode)) {
                if(qty >= 0) {
                    cartProducts[variantCode].quantity = parseInt(qty);
                    shoppingCartAPI.controller.save(ownerCode, cartProducts[variantCode]);
                } else {
                    delete cartProducts[variantCode];
                    cartCounter -= 1;
                    deleteCustomDesign = shoppingCartAPI.controller.delete(ownerCode, variantCode).then( () => {} );
                    if( deleteCustomDesign ) {
                        fileManager.deleteFile(1);
                    }
                }
            }

            totalQty = 0;

            for(let index in cartProducts) {
                totalQty += parseInt(cartProducts[index].quantity);
            }

            return {
                ...state,
                cartProducts: {
                    ...cartProducts
                },
                cartCounter,
                totalQty,
                designAttachment: deleteCustomDesign ? null : designAttachment
            };
        case actionTypes.LOAD_CART:
            cartProducts = action.payload.cartData;
            cartCounter = Object.values(cartProducts).reduce( (total, item) => {
                return total + (item.hasOwnProperty('quantity') ? 1 : 0);
            }, 0);
            totalQty = Object.values(cartProducts).reduce( (total, item) => {
                return total + (item.hasOwnProperty('quantity') ? item.quantity : 0);
            }, 0);

            return {
                ...state,
                cartProducts,
                cartCounter,
                totalQty,
                transactionNotes: cartProducts.transactionNotes
            };
        case actionTypes.CLEAR_CART:
            shoppingCartAPI.controller.clear(action.payload.ownerCode);

            return {
                ...INITIAL_STATE,
                designAttachment: state.designAttachment
            };

        case actionTypes.LOAD_DESIGN_ATTACHMENT:
            // const designAttachment = designAttachmentAPI.controller.get();

            return {
                ...state,
                designAttachment: action.payload.attachment
            };
        case actionTypes.SAVE_DESIGN_ATTACHMENT:
            // designAttachmentAPI.controller.save(action.payload.attachment);

            return {
                ...state,
                designAttachment: action.payload.attachment
            };
        case actionTypes.CLEAR_DESIGN_ATTACHMENT:
            // designAttachmentAPI.controller.clear();

            return {
                ...state,
                designAttachment: null
            };
        default: 
            return state;
    }
};

export default shopReducer;